<template>
  <div id="tickets">
    <div id="container">
      <div class="box">
        <transition name="fade">
          <div class="content" v-if="tickets.loaded && tickets.error === null">
            <datatable
              v-bind:items="tickets.data"
              v-bind:tableSettings="tableSettings">
            </datatable>

            <pagination
              v-bind:current_page="current_page"
              v-bind:total_pages="total_pages"
              v-bind:next="nextPage"
              v-bind:set="setPage"
              v-bind:prev="prevPage">
            </pagination>
          </div>
        </transition>

        <div class="loader" v-if="!tickets.loaded"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tickets } from '@/services/api/ApiRoutes';

export default {
  name: 'AllTickets',

  data() {
    const moment = this.$moment;

    // Set page title
    this.$parent.title.heading = 'Tickets';
    this.$parent.title.subheading = 'Dit zijn alle tickets.';

    return {
      tableSettings: {
        headings: ['Titel', 'Klant', 'Status', 'Medewerker', 'Laatste activiteit', 'Datum aangemaakt'],
        keys: [
          function title(item) {
            const length = 100;
            return (item.title.length > length) ? `${item.title.substring(0, length)}...` : item.title;
          },
          function client(item) {
            return item.client.name;
          },
          function status() {
            return 'Nieuw';
          },
          function status(item) {
            return item.user.fullName || 'Geen';
          },
          function lastActivity(item) {
            return moment(item.updated_at).fromNow();
          },
          function createdDate(item) {
            return moment(item.updated_at).format('D-M-YYYY');
          },
          function link(item) {
            return `/tickets/${item._id}`;
          },
        ],
      },
      tickets: {
        error: null,
        data: [],
        loaded: false,
      },
      per_page: 25,
      current_page: this.$route.query.page || 1,
      total_pages: 1,
    };
  },

  mounted() {
    this.getTickets();
  },

  methods: {
    getTickets() {
      Tickets.getAllPaged(this.per_page, this.current_page).then((tickets) => {
        this.tickets.error = null;
        this.tickets.data = tickets.items;
        this.tickets.loaded = true;
        this.total_pages = Math.ceil(tickets.total_count / this.per_page);

        if (this.current_page > this.total_pages) this.setPage(this.total_pages, true);
        if (this.current_page < 1) this.setPage(1, true);
      }).catch((error) => {
        this.tickets.error = error;
        this.tickets.loaded = true;
      });
    },

    nextPage() {
      if (this.current_page === this.total_pages) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(this.current_page, 10) + 1;
      this.$router.push(`/tickets/all?page=${this.current_page}`);
      this.getTickets();
    },

    setPage(page, force) {
      if ((this.current_page > this.total_pages || this.current_page < 0) && !force) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(page, 10);
      this.$router.push(`/tickets/all?page=${this.current_page}`);
      this.getTickets();
    },

    prevPage() {
      if (this.current_page <= 1) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(this.current_page, 10) - 1;
      this.$router.push(`/tickets/all?page=${this.current_page}`);
      this.getTickets();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tickets/AllTickets.vue